const SCORE_FRACTION_RE = /(-?\d+(?:\.\d+)?)\s*\/\s*(-?\d+(?:\.\d+)?)/;

export const formatPctValue = (value) => {
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  const rounded = Math.round(n * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
};

const readPercentCandidate = (row) => {
  const keys = ["percentage", "score_percent", "scorePercent", "pct", "percent"];
  for (const key of keys) {
    const value = row?.[key];
    if (value != null && value !== "") {
      const n = Number(value);
      if (!Number.isNaN(n)) return n;
    }
  }
  return null;
};

const parseScoreParts = (row) => {
  const directPercent = readPercentCandidate(row);
  if (directPercent != null) {
    return { percent: directPercent };
  }

  let score = row?.score;
  let total = row?.total_marks ?? row?.totalMarks;

  if (typeof score === "string" && SCORE_FRACTION_RE.test(score.trim())) {
    const match = score.trim().match(SCORE_FRACTION_RE);
    score = match?.[1];
    if (total == null || total === "") total = match?.[2];
  }

  const scoreNum = score != null && score !== "" ? Number(score) : null;
  const totalNum = total != null && total !== "" ? Number(total) : null;

  if (
    scoreNum != null &&
    !Number.isNaN(scoreNum) &&
    totalNum != null &&
    !Number.isNaN(totalNum) &&
    totalNum > 0
  ) {
    return { percent: (scoreNum / totalNum) * 100 };
  }

  if (scoreNum != null && !Number.isNaN(scoreNum)) {
    // Worksheets are stored as 0–100; mocks may only expose score without total_marks.
    if (totalNum == null || totalNum === 100) {
      return { percent: scoreNum };
    }
  }

  return { percent: null, raw: score };
};

/** Display resource score as a percentage for tutor tables and review headers. */
export const formatScorePercent = (row) => {
  if (!row) return "—";

  const { percent, raw } = parseScoreParts(row);
  if (percent != null) {
    const formatted = formatPctValue(percent);
    return formatted != null ? `${formatted}%` : "—";
  }

  if (raw != null && raw !== "") return String(raw);
  return "—";
};
